import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

export default function Volunteers({ user }) {
  const [volunteers, setVolunteers] = useState([]);
  const [filters, setFilters] = useState({city:'',skill:'all',availability:'all'});

  useEffect(()=>{
    const load = async () => {
      const q = query(collection(db,'users'),where('role','==','volunteer'),where('approved','==',true));
      const qs = await getDocs(q);
      setVolunteers(qs.docs.map(d=>({id:d.id,...d.data()})));
    };
    load();
  },[]);

  const skills = ['All Skills','Driving','Cooking','Childcare','Elder Care','Medical','Teaching','Repairs','Gardening','Shopping','Tech Help'];

  const filtered = volunteers.filter(v=>{
    if(filters.city && !v.city?.toLowerCase().includes(filters.city.toLowerCase())) return false;
    if(filters.skill!=='all' && !(v.skills||[]).includes(filters.skill)) return false;
    if(filters.availability!=='all' && v.availability!==filters.availability) return false;
    return true;
  });

  return (
    <div style={{minHeight:'100vh',background:'#F0FDF4'}}>
      <nav className="nav">
        <Link className="nav-brand" to="/"><div className="nav-logo">🏘</div><div className="nav-name">Community<span>Bridge</span></div></Link>
        <div className="nav-links">
          <Link to="/dashboard" className="nav-link">Home</Link>
          <Link to="/requests" className="nav-link">Requests</Link>
          <Link to="/events" className="nav-link">Events</Link>
          <Link to="/volunteers" className="nav-link active">Volunteers</Link>
        </div>
      </nav>
      <div className="page">
        <h1 className="page-title">👥 Volunteer Directory</h1>
        <p className="page-sub">Find verified volunteers in your community</p>

        <div className="card" style={{marginBottom:'1.5rem',padding:'1rem'}}>
          <div style={{display:'flex',gap:'10px',flexWrap:'wrap',alignItems:'center'}}>
            <input style={{width:'180px',padding:'6px 12px',fontSize:'13px'}} placeholder="Filter by city..." value={filters.city} onChange={e=>setFilters({...filters,city:e.target.value})}/>
            <select style={{width:'160px',padding:'6px 12px',fontSize:'13px'}} value={filters.skill} onChange={e=>setFilters({...filters,skill:e.target.value==='All Skills'?'all':e.target.value})}>
              {skills.map(s=><option key={s}>{s}</option>)}
            </select>
            <select style={{width:'160px',padding:'6px 12px',fontSize:'13px'}} value={filters.availability} onChange={e=>setFilters({...filters,availability:e.target.value})}>
              <option value="all">Any Availability</option>
              <option value="anytime">Anytime</option>
              <option value="weekdays">Weekdays</option>
              <option value="weekends">Weekends</option>
              <option value="evenings">Evenings</option>
            </select>
            <span style={{fontSize:'13px',color:'#6B7280'}}>{filtered.length} volunteers found</span>
          </div>
        </div>

        {filtered.length===0 ? (
          <div className="card" style={{textAlign:'center',padding:'3rem',color:'#6B7280'}}>
            <div style={{fontSize:'48px',marginBottom:'12px'}}>👥</div>
            <p style={{fontWeight:600}}>No verified volunteers found yet.</p>
            <p style={{fontSize:'14px',marginTop:'8px'}}>Be the first to get verified!</p>
          </div>
        ) : (
          <div className="grid3">
            {filtered.map(v=>(
              <div key={v.id} className="card">
                <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'12px'}}>
                  <div style={{width:'48px',height:'48px',borderRadius:'50%',background:'linear-gradient(135deg,#16A34A,#EA580C)',display:'flex',alignItems:'center',justifyContent:'center',color:'white',fontSize:'20px',fontWeight:800,flexShrink:0}}>
                    {(v.name||'V')[0].toUpperCase()}
                  </div>
                  <div>
                    <p style={{fontWeight:700,fontSize:'15px'}}>{v.name}</p>
                    <p style={{fontSize:'12px',color:'#6B7280'}}>📍 {v.city||'Location not set'}</p>
                  </div>
                </div>
                <div style={{display:'flex',gap:'6px',marginBottom:'8px',flexWrap:'wrap'}}>
                  <span className="badge badge-green">✅ Verified</span>
                  <span className="badge badge-blue">⭐ {v.rating||0}</span>
                  <span className="badge badge-gray">{v.completed_requests||0} tasks</span>
                </div>
                {(v.skills||[]).length>0 && (
                  <div style={{display:'flex',flexWrap:'wrap',gap:'4px',marginBottom:'10px'}}>
                    {v.skills.slice(0,3).map(s=><span key={s} className="badge badge-gray" style={{fontSize:'11px'}}>{s}</span>)}
                    {v.skills.length>3 && <span className="badge badge-gray" style={{fontSize:'11px'}}>+{v.skills.length-3}</span>}
                  </div>
                )}
                <p style={{fontSize:'12px',color:'#6B7280',marginBottom:'10px'}}>🕐 {v.availability||'Flexible'}</p>
                <button className="btn btn-secondary" style={{width:'100%',justifyContent:'center',fontSize:'13px'}}>View Profile</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
